import React, { Component } from 'react';
import { Static, Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import { FormGroup, ControlLabel, FormControl, Button, Alert } from 'react-bootstrap';
import AuthorizationRedirect from './AuthorizationRedirect';
import VerificationStatus from './VerificationStatus';
import { connect } from 'react-redux';
import {
	revokeAccessToken,
	GOCARDLESS_REVOKE_ACCESS_TOKEN_REQUEST, GOCARDLESS_REVOKE_ACCESS_TOKEN_SUCCESS, GOCARDLESS_REVOKE_ACCESS_TOKEN_FAILURE
} from './actions';
import { PAYMENT_METHODS_REQUEST, PAYMENT_METHODS_SUCCESS, PAYMENT_METHODS_FAILURE } from '../../actions';
import ReduxBlockUi from 'react-block-ui/redux';
import validators from '../../../../common/services/validators';

class GoCardlessForm extends Component {
	constructor(props) {
		super(props);
		this.handleConnectToLive = this.handleConnectToLive.bind(this);
		this.handleConnectToSandbox = this.handleConnectToSandbox.bind(this);
		this.handleDisconnect = this.handleDisconnect.bind(this);

		this.state = { redirect: false, useSandbox: true };
	}

	handleConnectToLive() {
		this.redirect(false);
	}

	handleConnectToSandbox() {
		this.redirect(true);
	}

	redirect(useSandbox) {
		this.setState({
			redirect: true,
			useSandbox
		});
	}

	handleDisconnect() {
		const { paymentConfigurationId, revokeAccessToken, onConfigurationUpdated } = this.props;
		revokeAccessToken({ paymentConfigurationId }, onConfigurationUpdated);
	}

	render() {
		const { t, enabled, configurationValues, onSubmit, ...rest } = this.props;
		const isConnected = configurationValues && configurationValues.accessToken;
		const isConnectedToSandbox = isConnected && configurationValues.useSandbox;

		return (
			<div>
				<FormGroup>
					{enabled && !isConnected && !isConnectedToSandbox && <Alert bsStyle='warning'>
						{t('GoCardless_EnabledNotConnected')}
					</Alert>}
					<ControlLabel>{t('GoCardless_ConnectDisconnect')}</ControlLabel>
					<FormControl.Static>
						<ReduxBlockUi
							block={[GOCARDLESS_REVOKE_ACCESS_TOKEN_REQUEST, PAYMENT_METHODS_REQUEST]}
							unblock={[GOCARDLESS_REVOKE_ACCESS_TOKEN_SUCCESS, GOCARDLESS_REVOKE_ACCESS_TOKEN_FAILURE, PAYMENT_METHODS_SUCCESS, PAYMENT_METHODS_FAILURE]}>
							{!isConnected && <Button bsStyle='primary' onClick={this.handleConnectToLive}>{t('GoCardless_ConnectLive')}</Button>}
							{!isConnected && <a style={{ display: 'block', marginTop: '15px', cursor: 'pointer' }} onClick={this.handleConnectToSandbox}>{t('GoCardless_ConnectSandbox')}</a>}
							{isConnected && <Button bsStyle='primary' onClick={this.handleDisconnect}>{t(isConnectedToSandbox ? 'GoCardless_DisconnectSandbox' : 'GoCardless_DisconnectLive')}</Button>}
							{isConnected && <div style={{ marginTop: '15px' }}><VerificationStatus useSandbox={isConnectedToSandbox} {...rest} /></div>}
							{this.state.redirect && <AuthorizationRedirect useSandbox={this.state.useSandbox} {...rest} />}
						</ReduxBlockUi>
					</FormControl.Static>
				</FormGroup>
				{/* Deliberately hidden rather than deleted - kept for re-enabling during support work. */}
				{/* eslint-disable-next-line no-constant-binary-expression */}
				{false && <Field name='accessToken' component={Static} type='text' label={t('GoCardless_AccessToken')} />}
				{/* eslint-disable-next-line no-constant-binary-expression */}
				{false && <Field name='organisationId' component={Static} type='text' label={t('GoCardless_OrganisationId')} />}
				<Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
				<Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
			</div>
		);
	}
}

export default connect(null, {
	revokeAccessToken
})(GoCardlessForm);